import React, { useContext, useEffect, useState } from 'react'
import { Form } from 'react-router-dom'

import { SocketContext } from '../context/SocketContext'

import { SelectElement } from './selectElement'
import LoadingOverlay from './LoadingOverlay'

export const UsuariosRolesPantallas = ( { usuario }  ) => {
    
    const { socket } = useContext( SocketContext );

    const [ isLoading, setIsLoading ] = useState(false);
    const [ rolSeleccionado, setRolSeleccionado ] = useState('');
    const [ roles, setRoles ] = useState('');
    const [ pantallas, setPantallas ] = useState([]);

    

    const usuarioRegistra = usuario.uidUsuario;
    const entidad = usuario.entidad;

    const datos={
        entidad
    }


    useEffect(() => {

        socket.on('roles-pantallas', ( lista ) => {
            setPantallas( lista )
        })

        return () => {
            socket.off('roles-pantallas')
        }


    }, [socket]);

    useEffect(() => {
        
        // async function fetchAtenciones() {
            // setIsLoading(true) 
            console.log(rolSeleccionado)
            datos.uidRolSeleccionado= rolSeleccionado
            
            setIsLoading(true)
            socket.emit('roles-pantallas', datos, ( lista ) => {
                setIsLoading(false)
                
                console.log(lista)
                setPantallas( lista )
                // setIsLoading(false) 
            })
        // }

        // fetchAtenciones();


        return () => {
            socket.off('roles-pantallas')
        }


    }, [rolSeleccionado]);


    const handleChecked = (checked, i) => {

        console.log(rolSeleccionado)
        if (rolSeleccionado== '' ) return false;

        let tmp = pantallas[i];
        tmp.checked = !checked;
        // let pantallasClone = [...pantallas];
        // pantallasClone[i] = tmp;
        // setRoles([...pantallasClone]);
        
        const data= {
            entidad,
            uidUsuario: usuario.uidUsuario,
            codigoPantalla: pantallas[i].codigoPantalla, 
            uidRolSeleccionado: pantallas[i].uidRolSeleccionado, 
            checked: tmp.checked
        }

        // console.log(data)
        
        setIsLoading(true) 
        socket.emit('edita-rol-pantalla', data, ( res ) => {
            setIsLoading(false) 
            console.log(res)

        })
        
    }

    useEffect(() => {
        async function fetchUsuarios() {

            setIsLoading(true)
            await socket.emit('select-Roles', datos, ( lista ) => {
                setIsLoading(false)
                const opciones = lista.map( (item) => ( { value: item.uidRol, label: item.rol.toUpperCase() } ) )
                setRoles( opciones )
                
            })
        }

        fetchUsuarios();
               
        return () => {
            socket.off('select-Usuarios')
        }
    }, [socket ])

  return (
    <>
        {isLoading && <LoadingOverlay />}
        
        <div className={`content ${isLoading ? 'opacity' : ''} m-5`}>

            <div className='row'>
                <div className='form-group col-lg-4 col-12'>
                                
                    <label> Roles </label>
                    <SelectElement
                        options= { roles }
                        name={"uidRol"}
                        isMulti= {false}
                        closeOnMenuSelect= {true}
                        onChange= {(ev) => setRolSeleccionado(ev?.value ) }
                        classname= "" 
                        seleccionado= {rolSeleccionado}
                        isClearable = {true}
                    />
                </div>

                <div className='form-group col-lg-8 col-12 rounded shadow p-3'>
                                
                    
                    <div className='col-12 '>
                        <table className='table table-responsive table-striped max600' width={'100%'}  >
                            <thead>
                                <tr>
                                    <th width={'5%'}></th>
                                    <th width={'95%'}>Pantallas</th>
                                </tr>
                            </thead>
                            <tbody width={'100%'} >
                                {pantallas.map((item, i) => (

                                    <tr key={item.codigoPantalla}>
                                        <td width={'5%'}>
                                    
                                            <div className="form-check form-switch">
                                            {/* { console.log(typeof(item.uidModulo), typeof(moduloSeleccionado) ) } */}
                                                <input 
                                                    className="form-check-input" 
                                                    checked= {item.checked } 
                                                    type="checkbox" 
                                                    id={`chkAsignado_${item.codigoPantalla}`} 
                                                    onChange={() => handleChecked(item.checked, i)  }
                                                    

                                                
                                                />

                                                <label className="form-check-label" htmlFor="chkAsignado_"></label>
                                            </div>


                                        </td>
                                        <td width={'95%'}> 
                                            {item.pantalla.toUpperCase()}
                                        </td>
                                    
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    
                    
                </div>
            
            
            </div>

        </div>
    </>


  )
}
